/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import PrimaryButton from 'components/form/buttons/primaryButton';
import DangerButton from 'components/form/buttons/danger';
import PaginationApp from 'components/pagination';
import EventFilterPopup from 'pages/panel/events/lib/filterForm';
import QuestionModal from 'components/modal/question';

import * as T from 'common/types';
import StatusChip from 'components/statusChip';
import Value from 'components/value';

import * as S from './styles';

interface IProps {
  data: { list: []; totalPages?: number; eventInfo?: T.Pages.EventItem };
  departments: [];
  loading: boolean;
}

export default function EventsContributorsTable({ data, departments, loading }: IProps) {
  const params = useParams();

  const [ShowAcceptModal, setShowAcceptModal] = useState(false);
  const [ShowRejectModal, setShowRejectModal] = useState(false);
  const [contributorData, setContributorData] = useState<T.Pages.ContributorItem | null>();

  const { eventContributorsRequestAction, eventContributorAcceptRequestAction, eventContributorRejectRequestAction } =
    useActions();

  const [meta, setMeta] = useState({
    page: 1,
    page_size: 1000,
    search: '',
    type: '',
    eventId: params?.id
  });

  const fetchData = () => {
    eventContributorsRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  const handleChangePage = (page: number) => {
    setMeta({ ...meta, page });
  };

  const handleChangePageSize = (page_size: number) => {
    setMeta({ ...meta, page_size });
  };

  const handleShowAcceptModal = (data: T.Pages.ContributorItem) => {
    setShowAcceptModal(true);
    setContributorData(data);
  };

  const handleHideAcceptModal = () => {
    setShowAcceptModal(false);
    setContributorData(null);
  };

  const handleAcceptContributor = () => {
    eventContributorAcceptRequestAction(contributorData?.id, () => {
      setShowAcceptModal(false);
      fetchData();
    });
  };

  const handleShowRejectModal = (data: T.Pages.ContributorItem) => {
    setShowRejectModal(true);
    setContributorData(data);
  };

  const handleHideRejectModal = () => {
    setShowRejectModal(false);
    setContributorData(null);
  };

  const handleRejectContributor = () => {
    eventContributorRejectRequestAction(contributorData?.id, () => {
      setShowRejectModal(false);
      fetchData();
    });
  };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox
            onChange={(e) => setMeta({ ...meta, search: e })}
            placeholder="Search"
            value={meta.search}
            disabled={!data.list?.length ? true : false}
          />
          <S.Grid>
            <EventFilterPopup setFilter={setMeta} filter={meta} departments={departments} contributor />
          </S.Grid>
        </S.Head>
        <Gap size="20px" />
        {data.list?.length ? (
          <AppTable
            headers={[
              { id: 1, key: 'id', title: 'User ID', dir: 'left', width: 100 },
              { id: 4, key: 'name', title: 'User Name', dir: 'left' },
              { id: 5, key: 'jobTitle', title: 'Job Title', dir: 'left', width: 150 },
              { id: 6, key: 'department', title: 'Department', dir: 'left', width: 140 },
              { id: 7, key: 'status', title: 'Status', width: 140 },
              { id: 8, key: 'requestLocation', title: 'Management', type: 'actions', width: 185 }
            ]}
            data={data.list}
            loading={loading}
            altanfeethiFields={{
              id: (item: T.Pages.ContributorItem) => <S.Div className="text-left">{item?.id}</S.Div>,

              name: (item: T.Pages.ContributorItem) => (
                <S.Div className="text-left captal">{item.userDisplayName}</S.Div>
              ),
              jobTitle: (item: T.Pages.ContributorItem) => <S.Div className="text-left">{item.userJobTitle}</S.Div>,
              department: (item: T.Pages.ContributorItem) => <S.Div className="text-left">{item.userDepartment}</S.Div>,
              status: (item: T.Pages.ContributorItem) => (
                <StatusChip domain="contributor" value={item?.status} fallback={<Value />} />
              ),

              requestLocation: (item: T.Pages.ContributorItem) => (
                <S.Grid className="flex-center">
                  {item.status === 'Pending' || item.status === 'Rejected' ? (
                    <PrimaryButton onClick={() => handleShowAcceptModal(item)} className="sm">
                      Accept
                    </PrimaryButton>
                  ) : (
                    <></>
                  )}
                  {item.status === 'Pending' || item.status === 'Attending' ? (
                    <DangerButton onClick={() => handleShowRejectModal(item)} className="danger sm">
                      Reject
                    </DangerButton>
                  ) : (
                    <></>
                  )}
                </S.Grid>
              )
            }}
          />
        ) : (
          <S.P>No contributors applied for this event yet.</S.P>
        )}
      </PanelBoxLayout>
      {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )}

      <QuestionModal
        handleClose={handleHideAcceptModal}
        show={ShowAcceptModal}
        model="success"
        handleSuccess={handleAcceptContributor}
        title="Are you sure Accept to this Contributor?"
        successButtonText="Accept"
      />

      <QuestionModal
        handleClose={handleHideRejectModal}
        show={ShowRejectModal}
        model="delete"
        handleSuccess={handleRejectContributor}
        title="Are you sure Reject to this Contributor?"
        successButtonText="Reject"
      />
    </S.Content>
  );
}
